export default {
  BULK_UPLOAD_SUCCESS: "BULK_UPLOAD_SUCCESS",
  BULK_UPLOAD_INTERNAL_ERROR: "BULK_UPLOAD_INTERNAL_ERROR",
  BULK_UPLOAD_DATA_MISMATCH: "BULK_UPLOAD_DATA_MISMATCH",
  BULK_UPLOAD_EMPTY_FILE: "BULK_UPLOAD_EMPTY_FILE",
  BULK_UPLOAD_PARTIAL_ADDED: "BULK_UPLOAD_PARTIAL_ADDED",
};
